// src/stone/icons/Accelerator2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Accelerator2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M19 10V5h2v5zM28.721 13.198l3.535-3.535 1.414 1.414-3.535 3.535zM9.861 14.612l-3.535-3.535L7.74 9.663l3.535 3.535zM33.334 22.333h5v2h-5zM22.514 19.92l8.164-2.188.517 1.932-8.164 2.188zM6.667 24.333h-5v-2h5z" }),
      /* @__PURE__ */ jsx("path", { d: "M22.334 21.667a2.333 2.333 0 1 0-4.667 0 2.333 2.333 0 0 0 4.666 0M20 17.333A4.333 4.333 0 1 1 20 26a4.333 4.333 0 0 1 0-8.667" }),
      /* @__PURE__ */ jsx("path", { d: "M.667 23.333C.667 12.656 9.323 4 20 4s19.333 8.656 19.333 19.333c0 4.673-1.66 8.961-4.42 12.304l-.3.363H5.387l-.3-.363a19.26 19.26 0 0 1-4.42-12.304M20 6C10.427 6 2.667 13.76 2.667 23.333c0 4.024 1.37 7.725 3.67 10.667h27.326a17.25 17.25 0 0 0 3.67-10.667C37.333 13.761 29.573 6 20 6" })
    ]
  }
);
var Accelerator2X_default = Accelerator2X;

export {
  Accelerator2X,
  Accelerator2X_default
};
